/* ============================================================
   MORIAH — transforma o seletor de cor em amostras 3D
   (dourado, prateado e demais tons metálicos)
   ============================================================ */
(() => {
  const TONS = {
    dourado:  'linear-gradient(135deg,#FBEFC4 0%,#E3C169 22%,#B8892F 48%,#8A6420 62%,#E8CB7E 82%,#FBEFC4 100%)',
    ouro:     'linear-gradient(135deg,#FBEFC4 0%,#E3C169 22%,#B8892F 48%,#8A6420 62%,#E8CB7E 82%,#FBEFC4 100%)',
    prateado: 'linear-gradient(135deg,#FFFFFF 0%,#DDE1E6 22%,#A9B0B8 48%,#7E868F 62%,#D6DBE0 82%,#FFFFFF 100%)',
    prata:    'linear-gradient(135deg,#FFFFFF 0%,#DDE1E6 22%,#A9B0B8 48%,#7E868F 62%,#D6DBE0 82%,#FFFFFF 100%)',
    rose:     'linear-gradient(135deg,#FDE3DC 0%,#E8B4A4 25%,#C98070 50%,#A75F52 65%,#F0C6B8 85%,#FDE3DC 100%)',
    'rose gold':'linear-gradient(135deg,#FDE3DC 0%,#E8B4A4 25%,#C98070 50%,#A75F52 65%,#F0C6B8 85%,#FDE3DC 100%)',
    preto:    'linear-gradient(135deg,#5A5A5A 0%,#2B2B2B 30%,#111111 55%,#000000 70%,#3A3A3A 90%)',
    branco:   'linear-gradient(135deg,#FFFFFF 0%,#F2F2F2 45%,#DCDCDC 70%,#FFFFFF 100%)',
    azul:     'linear-gradient(135deg,#BBD6F5 0%,#4A83C7 35%,#1B4F91 60%,#123869 72%,#7FB0E4 92%)',
    'azul claro':'linear-gradient(135deg,#DDEEFF 0%,#A8CDEF 35%,#6FA6D6 60%,#4C86BB 75%,#CDE6FB 95%)',
    vermelho: 'linear-gradient(135deg,#FFC2BC 0%,#D8352A 35%,#9E1B12 60%,#77120C 72%,#EE6A60 92%)',
    verde:    'linear-gradient(135deg,#C7E9CE 0%,#3E9B57 35%,#1F6B37 60%,#154E28 72%,#7CC58F 92%)',
    rosa:     'linear-gradient(135deg,#FFDDEA 0%,#F08BB4 35%,#CE5A8B 60%,#A64069 72%,#FBB6D0 92%)',
    bege:     'linear-gradient(135deg,#F7EFE3 0%,#E4D3BC 35%,#C8B091 60%,#A98F6D 72%,#F0E4D2 92%)',
    champagne:'linear-gradient(135deg,#FBF3E3 0%,#E9D9B8 30%,#CDB98C 55%,#B09E72 70%,#F3E8CE 92%)',
  };

  const semAcento = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

  function tom(texto) {
    const t = semAcento(texto);
    if (TONS[t]) return TONS[t];
    const chave = Object.keys(TONS).find((k) => t === k || t.startsWith(k + ' ') || t.endsWith(' ' + k));
    return chave ? TONS[chave] : null;
  }

  function pintar(raiz = document) {
    const grupos = raiz.querySelectorAll('.variant-option, variant-picker fieldset, .variant-picker__option');
    grupos.forEach((grupo) => {
      const alvo = grupo.querySelector('legend, .variant-option__label');
      const rotulo = semAcento((alvo ? alvo.textContent : grupo.textContent.slice(0, 20)) || '');
      if (!rotulo.includes('cor') && !rotulo.includes('color')) return;

      grupo.querySelectorAll('label').forEach((el) => {
        if (el.dataset.ovzSwatch) return;
        const entrada = el.querySelector('input');
        const nome = (entrada && entrada.value ? entrada.value : el.textContent).trim();
        const grad = tom(nome);
        if (!grad) return;
        el.dataset.ovzSwatch = '1';
        el.style.setProperty('--ovz-sw', grad);
        el.setAttribute('title', nome);
        el.setAttribute('aria-label', nome);
        el.classList.add('ovz-swatch');
      });
    });
  }

  const iniciar = () => {
    pintar();
    new MutationObserver((ms) => {
      for (const m of ms) if (m.addedNodes.length) { pintar(); break; }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* ============================================================
   MORIAH — "+ ADICIONAR" nas recomendações do carrinho
   ============================================================ */
(() => {
  document.addEventListener('submit', async (ev) => {
    const form = ev.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ovz-add')) return;
    ev.preventDefault();
    const botao = form.querySelector('button');
    if (botao) { botao.classList.add('is-loading'); botao.textContent = 'ADICIONANDO...'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }],
        }),
      });
      if (!res.ok) throw new Error(await res.text());
      // o tema recarrega o carrinho sozinho ao ouvir este evento
      document.dispatchEvent(
        new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ovza-recs' } } })
      );
      if (botao) { botao.textContent = 'ADICIONADO'; }
    } catch (e) {
      console.error('Moriah: falha ao adicionar', e);
      form.removeAttribute('data-ovz-add');
      form.submit();
    } finally {
      if (botao) setTimeout(() => { botao.classList.remove('is-loading'); botao.textContent = '+ ADICIONAR'; }, 1200);
    }
  });
})();
